<span class="close-modal-outside"><i (click)="ActiveModal.dismiss()" class="im-icon im-icon-x-light"></i></span>
<div class="modal-wrap">
  @if (!ready || !resourcesReady) {
    <app-spinner [centerVertically]="true"></app-spinner>
  }
  @if (project) {
    <div class="d-flex detail-modal">
      <!-- start form -->
      <div class="d-flex flex-column w-100 flex-grow-1 scroll-y">
        @if (loading) {
          <div style="height: 100%;">
            <app-spinner [centerVertically]="true"></app-spinner>
          </div>
        }
        @if (!loading && ready && resourcesReady) {
          <div class="">
            <div class="detail-modal-header d-flex flex-row justify-content-between align-items-center" style="min-height: 36px;">
              <h1 style="min-height: 36px;"> {{id ? ('Project '+project.name) : 'New project'}}</h1>
              <div class="h-100 d-flex align-items-center">
                <button class="button tertiary" (click)="canExit() && ActiveModal.dismiss()" [class.disabled]="saving"><span>Annuleer</span></button>
                <app-button classes="primary-default ml-xs" icon="check-round-filled" text="Bewaar" [disabled]="saving" [submitting]="submitting" (emitClick)="createUpdateDiscount()"></app-button>
              </div>
            </div>
            <div class="detail-modal-body">
              <!-- content -->
              <div class="row display-row">
                <div class="col-xl-4">
                  <!-- type -->
                  <div class="display-content">
                    <ng-container>
                      <app-field-text
                        [model]="formSTR.name"
                        (modelChange)="formSTR.name = $event; formChange();"
                        label="Name"
                        placeholder=""
                        [error]="validation.name">
                      </app-field-text>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="row display-row">
                <div class="col-xl-4">
                  <!-- type -->
                  <div class="display-content">
                    <ng-container>
                      <app-field-select
                        [model]="formSTR.lnk_client_id"
                        [options]="clientARR"
                        (modelChange)="formSTR.lnk_client_id = $event; formChange();"
                        label="Client"
                        [error]="validation.lnk_client_id"
                        placeholder="">
                      </app-field-select>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="row display-row">
                <div class="col-xl-4">
                  <!-- type -->
                  <div class="display-content">
                    <ng-container>
                      <app-field-text
                        [model]="formSTR.lnk_group_id"
                        (modelChange)="formSTR.lnk_group_id = $event; formChange();"
                        label="AD group"
                        placeholder=""
                        [error]="validation.lnk_group_id">
                      </app-field-text>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>